import { Navigate, useParams } from 'react-router-dom';

interface JobBoardRedirectProps {
  target: string;
}

export default function JobBoardRedirect({ target }: JobBoardRedirectProps) {
  const params = useParams();
  const destination = target.replace(/:([A-Za-z]+)/g, (_, key: string) => params[key] ?? '');

  return <Navigate to={destination} replace />;
}
